export function MagicOverlay({ stage }) {
  const steps = [
    { key: "reading", label: "希望データを読み込んでいます", emoji: "📋" },
    { key: "placing", label: "ベストな配置を計算中", emoji: "✨" },
    { key: "finalizing", label: "最終調整中…完成まであと少し", emoji: "🪄" },
  ];
  const activeIdx = steps.findIndex((s) => s.key === stage);
  return (
    <div className="fixed inset-0 z-50 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center p-4" data-testid="magic-overlay">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full text-center relative overflow-hidden">
        {/* Sparkle particles */}
        <div className="absolute inset-0 pointer-events-none">
          {[...Array(8)].map((_, i) => (
            <span
              key={i}
              className="absolute w-2 h-2 bg-amber-300 rounded-full opacity-70 animate-ping"
              style={{
                top: `${10 + (i * 11) % 80}%`,
                left: `${5 + (i * 13) % 90}%`,
                animationDelay: `${i * 0.25}s`,
                animationDuration: "1.8s",
              }}
            />
          ))}
        </div>
        <div className="relative">
          <img
            src="/yasamaru-cast-256.png"
            alt="やさまる"
            className="w-32 h-32 mx-auto mb-2 animate-bounce"
            style={{ animationDuration: "1.4s" }}
          />
          <h3 className="text-xl font-bold text-slate-900 mb-1">やさまるが配置中…</h3>
          <p className="text-xs text-slate-500 mb-5">少々お待ちください…</p>
          <ul className="text-left space-y-2 max-w-xs mx-auto">
            {steps.map((s, i) => {
              const isActive = i === activeIdx;
              const isDone = i < activeIdx;
              return (
                <li key={s.key} className={`flex items-center gap-2 text-sm transition-all ${
                  isDone ? "text-emerald-700" : isActive ? "text-purple-700 font-bold" : "text-slate-400"
                }`}>
                  <span className={`w-6 h-6 flex items-center justify-center rounded-full text-xs ${
                    isDone ? "bg-emerald-100" : isActive ? "bg-purple-100" : "bg-slate-100"
                  }`}>
                    {isDone ? "✓" : isActive ? <span className="animate-pulse">{s.emoji}</span> : s.emoji}
                  </span>
                  <span>{s.label}{isActive && <span className="animate-pulse">…</span>}</span>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
}
